
import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { BillOfLadingModel } from '@/models/bill-of-lading';
import ListPackage from './components/ListPackage.vue';
import formatNumber from '@/shared/filters/format-number';
import authService from '@/services/auth-services';
import receiptServices from '@/services/receipt-services';
const numeral = require('numeral');
@Component({
    components: {
        ListPackage,
        Loading,
        Paging
    }
})
export default class DetailReceipt extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    get receiptId() {
        return this.$route.params.id;
    }
    private listPackage: BillOfLadingModel[] = [];
    private isLoading = false;
    private customerInfo: any = {};

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    @Watch('receiptId', { immediate: true, deep: true })
    private async watchReceiptId() {
        if (this.receiptId) {
            this.initComponent();
        }
    }

    private async initComponent() {
        await this.loadData();
        await this.getCustomersInfo();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        const result = await receiptServices.getBillOfLading(this.receiptId, authProvider.getToken());
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpList: BillOfLadingModel[] = [];
            this.pageSettings.total = result.data.data.order_transactions.length;
            for (const item of result.data.data.order_transactions) {
                const bill = new BillOfLadingModel();
                bill.id = item.ID;
                bill.createdBy = item.CreatedBy;
                bill.createdDate = item.CreatedDate;
                bill.id = item.ID;
                bill.modifiedBy = item.ModifiedBy;
                bill.modifiedDate = item.ModifiedDate;
                bill.orderCodeId = item.OrderCodeID;
                bill.orderId = item.OrderID;
                bill.transactionCode = item.TransactionCode;
                bill.productName = item.ProductName;
                bill.productAmount = item.ProductAmount;
                bill.numberOfPack = item.NumberOfPack;
                bill.productNumber = item.ProductNumber;
                bill.packageType = item.PackageType;
                bill.status = item.Status;
                bill.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                bill.uId = item.UID;
                bill.userName = item.Username;
                bill.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')}` : '';
                bill.weightByVolume = item.WeightByVolume > 0 ? `${formatNumber(item.WeightByVolume, '0,0.[0000]')}` : '';
                bill.volume = item.Width > 0 ? `${item.Length} x ${item.Width} x ${item.Height}` : '';

                tmpList.push(bill);
            }
            this.listPackage = tmpList;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        return paramsFilter;
    }
}
